export default __webpack_public_path__ + "static/media/profile.38385c2d.jpeg";